export enum ContactFormatEnum {
    NameSurname = 0,
    SurnameName = 1
}